import gql from 'graphql-tag'

export const TRIGGER_CHANNEX_FULL_SYNC_MUTATION = gql`
  mutation TriggerChannexFullSync {
    triggerChannexFullSync {
      availabilityTaskIds
      restrictionTaskIds
    }
  }
`
